import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Item, RootObject } from "../../../interfaces/GoogleBookApi";
import UploadService from "../../../services/upload/UploadService";
import "../ProjectPaperback/ProjectPaperbackAdmin.css";
import Loading from "../../Loading/Loading";

//initialize some state variable placeholders
const defaultResult: RootObject = {
  kind: "",
  totalItems: 0,
  items: [],
};

const ProjectPaperbackAdmin = () => {
  //state management
  const [searchResults, setSearchResults] = useState(defaultResult);
  const [currentBook, setCurrentBook] = useState<Item>();
  const [pdfFile, setPdfFile] = useState<Blob>();
  const [pdfError, setPdfError] = useState("");
  const [bookError, setBookError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  //helper function if admin uploads from their local computer
  const uploadPdf = async () => {
    const pdfLocation = await UploadService.uploadPDFToLibrary(pdfFile as Blob, currentBook?.id || "");
    const downloadUrl = await UploadService.getLibraryBookDownload(pdfLocation);
    return { pdfLocation, downloadUrl };
  };

  //main function that does all the magic
  //1.uploads pdf to backend,
  //2. converts pdf using cloud convert tasks
  //3. writes data to firestore and stores files in firebase storage.
  const save = async () => {
    //if we do not have all the data then we return and throw an error. Logic is janky but idc.
    if (!currentBook) {
      setBookError("Book is required.");
      return;
    }
    if (!pdfFile) {
      setPdfError("PDF is required.");
      return;
    }

    setIsLoading(true);
    ///upload pdf to firebase backend
    try {
      const { pdfLocation, downloadUrl } = await uploadPdf();

      const url = `https://us-central1-${
        process.env.REACT_APP_ENV === "production" ? "readtome-272220" : "readtomedev-81db7"
      }.cloudfunctions.net/savePaperbackBook`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          downloadUrl,
          pdfLocation,
          book: currentBook,
        }),
      });
      const json = await response.json();

      console.log("savePaperbackBook response", json);

      setIsLoading(false);
      setSuccessMessage(`Successfully uploaded document: Your document id is ${json.book.id}`);
    } catch (e) {
      setIsLoading(false);
      console.error("savePaperbackBook error", e);
    }
  };

  //our handlers for text input

  //calls google books api then sets our state to the results
  const handleSearch = (event: React.FormEvent<{ value: unknown }>) => {
    if (!event.currentTarget.value || event.currentTarget.value === "") {
      return;
    }
    setSuccessMessage("");
    setCurrentBook(undefined);

    try {
      fetch(
        "https://www.googleapis.com/books/v1/volumes?q=" +
          event.currentTarget.value +
          "&key=AIzaSyCKZEGdCf-wbU5uWg8PYd1er8k4u_yqWMA",
      )
        .then(response => response.json())
        .then(json => {
          const result = json as RootObject;

          setSearchResults(result);
        });
    } catch (e) {
      console.log("Something went wrong searching google book api" + e);
    }
  };

  const handlePdfFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSuccessMessage("");
    const pdfFile = event?.target?.files?.[0];
    if (pdfFile) {
      setPdfFile(pdfFile);
    }
  };

  //here is the actual render
  return isLoading ? (
    <Loading />
  ) : (
    <div className="mainBody">
      <br />
      <Link to="/Home">Go Back</Link>
      <br />
      <p className="error">{bookError}</p>
      <b>Search For Your Book</b>
      <br />
      <input
        onChange={event => {
          handleSearch(event);
        }}
      ></input>
      <br />
      {currentBook && (
        <div>
          Selected <b>{currentBook.volumeInfo.title}</b>
        </div>
      )}
      {searchResults.items?.map(item => {
        let className = "item";
        if (item.id === currentBook?.id) {
          className = "item active";
        }

        return (
          <div key={item.id}>
            <button
              className={className}
              onClick={() => {
                setBookError("");
                setCurrentBook(item);
                setSearchResults(defaultResult);
              }}
            >
              <div className="text">
                <p>{item.volumeInfo.title}</p>
                {item.volumeInfo?.authors?.map((author, index) => {
                  return <span key={author + index}>{`${author}, `}</span>;
                })}
              </div>

              <img alt="Book thumbnail" className="image" src={item.volumeInfo.imageLinks?.smallThumbnail} />
            </button>
          </div>
        );
      })}
      <br />
      <b>Upload File</b>
      <p className="error">{pdfError}</p>

      <br />
      <div className="mainBody">
        <input type="file" onChange={handlePdfFile}></input>
      </div>

      <br />
      <button name="Upload and Convert" onClick={save}>
        Submit
      </button>
      <br />

      {successMessage}

      <br />
    </div>
  );
};

export default ProjectPaperbackAdmin;
